import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'mes'
})
export class MesPipe implements PipeTransform {
    transform(value: number): string {
        if (value) {
            if (value < 10) {
                return (`0${value}`);
            } else {
                return value.toString();
            }
        } else {
            return value.toString();
        }
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/mes.pipe.ts